var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { BetBtn } from "../";
import { observer } from "mobx-react";
var PreLiveOutright = /** @class */ (function (_super) {
    __extends(PreLiveOutright, _super);
    function PreLiveOutright(props) {
        var _this = _super.call(this, props) || this;
        _this.componentPrefix = "prelive-outright";
        return _this;
    }
    PreLiveOutright.prototype.renderButtonsHolder = function (s) {
        var _this = this;
        return (React.createElement("div", { key: this.componentPrefix + "__button-holder__" + s.id, className: "rj-ev-list__" + this.componentPrefix + "__button-holder", "data-uat": "div-ev-list-" + this.componentPrefix + "-button-holder" },
            React.createElement(BetBtn, { key: this.componentPrefix + "__bet-btn__" + s.id, classNames: s.isSelectionInBetslip ? "rj-ev-list__bet-btn--chosen" : "", isDisabled: s.isDisabled, text: s.name, odd: s.odds, trueOdds: s.trueOdds, handler: function () { return _this.props.betButtonHandler(_this.props.market, s); }, hideLowOdds: this.props.hideLowOdds })));
    };
    PreLiveOutright.prototype.renderSelections = function () {
        var viewOutright = [];
        var selections = this.props.market.selections;
        var count = this.props.market.selections.length > this.props.numberOfSelectionsToShow
            ? this.props.numberOfSelectionsToShow
            : this.props.market.selections.length;
        for (var i_1 = 0; i_1 < count; i_1 += 1) {
            viewOutright.push(this.renderButtonsHolder(selections[i_1]));
        }
        (selections.length > count) &&
            viewOutright.push(React.createElement(React.Fragment, { key: this.componentPrefix + "-" + this.props.market.id }, this.props.children));
        return viewOutright;
    };
    PreLiveOutright.prototype.render = function () {
        return (React.createElement("div", { className: "rj-ev-list__" + this.componentPrefix + "__wrap", "data-uat": "div-ev-list-" + this.componentPrefix + "-wrap" }, this.renderSelections()));
    };
    PreLiveOutright = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], PreLiveOutright);
    return PreLiveOutright;
}(React.Component));
export { PreLiveOutright };
//# sourceMappingURL=PreLiveOutright.js.map